import type { GuildEvent, GuildRejected } from '@shefira/shared';

import { uiFormat } from './text.js';

/** What the chat says when something happens to the guild (ADR 0036). */
export function guildEventText(event: GuildEvent): string {
  switch (event.kind) {
    case 'created':
      return uiFormat('La guilde {name} est fondée.', { name: event.name });
    case 'invited':
      return uiFormat('Invitation dans la guilde envoyée à {name}.', { name: event.name });
    case 'joined':
      return uiFormat('{name} rejoint la guilde.', { name: event.name });
    case 'left':
      return uiFormat('{name} quitte la guilde.', { name: event.name });
    case 'kicked':
      return uiFormat('{name} est exclu de la guilde.', { name: event.name });
    case 'declined':
      return uiFormat("{name} décline l'invitation dans la guilde.", { name: event.name });
    case 'expired':
      return uiFormat("{name} n'a pas répondu à l'invitation dans la guilde.", {
        name: event.name,
      });
    case 'promoted':
      return uiFormat('{name} est promu officier.', { name: event.name });
    case 'demoted':
      return uiFormat('{name} redevient simple membre.', { name: event.name });
    case 'leader':
      return uiFormat('{name} mène désormais la guilde.', { name: event.name });
    case 'motd':
      return uiFormat('{name} change la devise de la guilde.', { name: event.name });
    case 'disbanded':
      return uiFormat('La guilde {name} est dissoute.', { name: event.name });
    case 'levelled':
      return uiFormat('{name} passe au niveau {level} !', {
        name: event.name,
        level: event.level ?? '?',
      });
  }
}

export const GUILD_REFUSAL_TEXT: Record<GuildRejected['reason'], string> = {
  invalid: 'Demande refusée.',
  'not-found': "Personne de ce nom n'est en jeu.",
  self: 'Tu ne peux pas faire ça avec toi-même.',
  'already-in-guild': 'Ce joueur est déjà dans une guilde.',
  'in-guild': "Tu es déjà dans une guilde. Quitte-la d'abord.",
  'no-guild': "Tu n'es pas dans une guilde.",
  'not-allowed': 'Ton rang ne le permet pas.',
  full: 'La guilde est complète.',
  pending: 'Une invitation attend déjà sa réponse.',
  'no-invite': "Cette invitation n'est plus valable.",
  'not-member': "Ce joueur n'est pas dans ta guilde.",
  'missing-gold': "Tu n'as pas assez d'or pour fonder une guilde.",
  'name-taken': 'Ce nom de guilde est déjà pris.',
  'tag-taken': 'Ce tag est déjà pris.',
  'name-refused': 'Ce nom ou ce tag ne convient pas.',
};
